module.exports = __webpack_public_path__ + "img/10.039f2c8e.webp";